<template>
  <div>
    <img :src="isImage ? image : ''"
         id="image"
         style="display: none;">
    <div v-show="store.fileviewer.active && !isImage"
         class="viewer-container viewer-backdrop file-viewer-class viewer-fixed viewer-fade viewer-transition viewer-in"
         touch-action="none" style="z-index: 2015;">
      <div class="viewer-canvas" data-viewer-action="hide">
        <div id="pdfFileViewer">
          <div id="viewer" class="pdfViewer"/>
        </div>
      </div>
      <div role="button"
           class="viewer-button viewer-close"
           data-viewer-action="mix"
           @click="closeFileViewer"></div>
    </div>
  </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css'
  import store from '../config/store'
  import Viewer from 'viewerjs'

  export default {

    data: () => ({
      store,
      viewer: null,
      pdfViewer: null
    }),

    computed: {
      image () {
        return store.fileviewer.image
      },

      isImage () {
        return this.image && typeof this.image === 'string' && this.image.includes('image/')
      }
    },

    watch: {
      'store.fileviewer.active': function () {
        if (store.fileviewer.active) {
          if (this.isImage) {
            if (!this.viewer) {
              this.initImageViewer()
            }
            this.viewer.show()
          } else {
            const container = document.getElementById('pdfFileViewer')
            this.pdfViewer = new PDFJS.PDFViewer({
              container: container
            })
            this.pdfViewer.setDocument(this.image)
          }
        }
      }
    },

    methods: {
      initImageViewer () {
        // View an image
        this.viewer = new Viewer(document.getElementById('image'), {
          className: 'file-viewer-class',
          toolbar: {
            zoomIn: 1,
            zoomOut: 1,
            oneToOne: 0,
            reset: 0,
            prev: 0,
            play: 0,
            next: 0,
            rotateLeft: 0,
            rotateRight: 0,
            flipHorizontal: 0,
            flipVertical: 0,
          },
          hidden: () => {
            this.closeFileViewer()
          }
        })
      }
    }

  }
</script>
